import script from "./SiteNav.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteNav.vue?vue&type=script&setup=true&lang=js"

import "./SiteNav.vue?vue&type=style&index=0&id=abdf7ffc&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abdf7ffc"]])

export default __exports__